import { render, staticRenderFns } from "./actuvutyGoodList.vue?vue&type=template&id=90bc1dce&scoped=true"
import script from "./actuvutyGoodList.vue?vue&type=script&lang=js"
export * from "./actuvutyGoodList.vue?vue&type=script&lang=js"
import style0 from "./actuvutyGoodList.vue?vue&type=style&index=0&id=90bc1dce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bc1dce",
  null
  
)

export default component.exports